import { useState } from 'react';
import ReportModal from './ReportModal';

interface ReportButtonProps {
  targetType: 'STORY' | 'REVIEW' | 'COMMENT' | 'CHAPTER_COMMENT' | 'FORUM_POST' | 'USER' | 'MESSAGE';
  targetId: number;
  targetLabel?: string;
  className?: string;
  variant?: 'icon' | 'text' | 'menu';
}

export default function ReportButton({ targetType, targetId, targetLabel, className = '', variant = 'icon' }: ReportButtonProps) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {variant === 'icon' && (
        <button
          onClick={() => setShowModal(true)}
          className={`text-gray-400 hover:text-red-500 transition-colors ${className}`}
          title="Report"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9" />
          </svg>
        </button>
      )}

      {variant === 'text' && (
        <button
          onClick={() => setShowModal(true)}
          className={`text-sm text-gray-400 hover:text-red-500 transition-colors ${className}`}
        >
          Report
        </button>
      )}

      {variant === 'menu' && (
        <button
          onClick={() => setShowModal(true)}
          className={`w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors ${className}`}
        >
          Report this content
        </button>
      )}

      <ReportModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        targetType={targetType}
        targetId={targetId}
        targetLabel={targetLabel}
      />
    </>
  );
}
